import CompleteJobPage from './CompleteJobPage';

export default CompleteJobPage;